/** @type {import('next-i18next').UserConfig} */

/**
 * NOTE: Can't import the constants here since our constants are in typescript.
 * Using hardcoded values below based on the constants in src/config/i18n.config.ts
 */
module.exports = {
  i18n: {
    defaultLocale: 'default-locale',
    locales:
      process.env.NEXT_PUBLIC_ENABLE_I18N === 'true'
        ? ['default-locale', 'us', 'ca', 'en-us', 'en-ca', 'fr-ca']
        : ['default-locale'],
    localeDetection: false,
  },
  fallbackLng: locale => {
    const normalizedLocale = locale.toLowerCase();
    if (normalizedLocale === 'en-ca') return 'en-us'
    if (normalizedLocale === 'en-us') return 'en-us'
    if (normalizedLocale === 'fr-ca') return 'fr-ca'
    return 'en-us'
  },
  localePath: './public/locales',
  localeStructure: '{{lng}}/{{ns}}',
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  serializeConfig: false,
  load: 'currentOnly',
  returnNull: false,
  returnEmptyString: false,
  returnObjects: true,
  saveMissing: process.env.NODE_ENV === 'development',
  missingKeyHandler: false,
  cleanCode: true,
  lowerCaseLng: true,
  appendNamespaceToCIMode: false,
  initImmediate: false,
  detection: {
    lookupCookie: 'NEXT_PREFERRED_LOCALE',
    caches: ['cookie'],
    order: ['cookie', 'header'],
    lookupFromPathIndex: 0,
    convertCase: 'lower'
  }
}
